<div class="body-main">
  <div class="body-main-top">
    <section class="container-fluid mt-2 mt-md-3 mb-4">
      <div class="row">
        <div class="box col-12">
          <div class="box-header">
            <div class="box-title">
              <div class="row align-items-center">
                <div class="col" *ngIf="!check">
                  <h3>Accounts</h3>
                </div>
                <div class="col" *ngIf="check">
                  <h3>{{accountName}}</h3>
                </div>
                <div class="col-auto" *ngIf="!check">
                  <button *ngIf="(accAdd == 1)?true:false" type="button" (click)="addAccount()"
                    class="btn add-button"><i class="fa fa-plus d-inline-block" title="Create Account"></i></button>
                </div>
                <div class="col-auto" *ngIf="check">
                  <button type="button" (click)="backHome()" class="btn btn-primary hBack"><i
                      title="Back to Account">Back</i></button>
                </div>
              </div>
            </div>
          </div>

          <div class="row" *ngIf="!hideHadder">
            <div class="col-md-3" *ngFor="let account of accountData; let i = index"
              [isOpened]="((i == 0 && selAccount == '') || selAccount == account._id)?true:false" id="acc_coll_{{i}}">
              <div class="account-box">
                <div class='drill_cursor'>
                  <span title="Edit Account" class="edit-account"> <i class="fa fa-pencil"
                      *ngIf="(accEdit == 1)?true:false" (click)="accountEdit(account._id)"></i></span>
                  <button class="" (click)="openProject(account)">
                    <h1>{{account.accountName}}</h1>
                    <h2>{{account.projectCount}}</h2>
                    <h3>Projects</h3>
                    <!-- <i class="fa d-inline fa-lg fa-newspaper-o right"
                    (click)="openProject(i)" class="fa fa-plus"></i> -->
                  </button>
                  <div class="pro-add-btn">
                    <h4>Create project<span title="Create Project">
                        <i *ngIf="(prjAdd == 1)?true:false" class="fa d-inline fa-lg fa-newspaper-o right"
                          (click)="addProject(account._id)" class="fa fa-plus"></i></span></h4>
                  </div>
                </div>
              </div>

            </div>

          </div>
          <div *ngIf="(prjView == 1)?true:false">
            <div class="row" *ngIf="check">
              <div class="col-md-4"
                *ngFor="let proj of accountValue.project | paginate: { itemsPerPage: 9, currentPage: p, totalItems: accountValue.projectCount,id: i }; let i = index;"
                (mouseenter)="mouseEnter(i) " (mouseleave)="mouseLeave('')">
                <div class="project-box">
                  <div class="project-count">{{i+1}}</div>
                  <div class="project-cont">
                    <h1>{{proj.projectName}}</h1>
                    <h2>Identifier : {{proj.projectIdentifier}}</h2>
                    <ul>
                      <li><a target="_blank" routerLink="/acp/{{proj._projectid}}"><span title="Admin"> <i
                              class="fa fa-user-circle-o"></i></span></a></li>
                      <li *ngIf="(createruleView == 1)?true:false"
                        (click)="goAppRuleEngine(accountValue._id,proj._projectid)"><a href="#"><span
                            title="Create Rule">
                            <i class="fa fa-plus-circle"></i></span></a></li>
                      <li *ngIf="(createappView == 1)?true:false"
                        (click)="goApplication(accountValue._id,proj._projectid)"><a href="#"><span
                            title="Create Application"> <i class="fa fa-th"></i></span></a></li>
                      <li *ngIf="(createruleView == 1)?true:false" (click)="goAge(accountValue._id,proj._projectid)"><a
                          href="#"><span title="Age"> <i class="fa fa-info-circle"></i></span></a>
                      </li>
                      <li *ngIf="(prjEdit == 1)?true:false" (click)="projectEdit(accountValue._id,proj._projectid)"><a
                          href="#"><span title="Edit"> <i class="fa fa-edit"></i></span></a></li>
                    </ul>
                    <div class="project-box-hover">
                      <ul>
                        <li><a target="_blank" routerLink="/acp/{{proj._projectid}}"><span title="Admin"> <i
                                class="fa fa-user-circle-o"></i> Admin</span></a></li>
                        <li *ngIf="(createruleView == 1)?true:false"
                          (click)="goAppRuleEngine(accountValue._id,proj._projectid)"><span title=""> <i
                              class="fa fa-plus-circle"></i> Create Rule</span></li>
                        <li *ngIf="(createappView == 1)?true:false"
                          (click)="goApplication(accountValue._id,proj._projectid)"><span title=""> <i
                              class="fa fa-th"></i> Create Application</span></li>
                        <li *ngIf="(createruleView == 1)?true:false" (click)="goAge(accountValue._id,proj._projectid)">
                          <span title=""> <i class="fa fa-info-circle"></i></span> Age
                        </li>
                        <li *ngIf="(prjEdit == 1)?true:false" (click)="projectEdit(accountValue._id,proj._projectid)">
                          <span title="Edit"> <i class="fa fa-edit"></i></span> Edit
                        </li>
                      </ul>

                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="clearfix"></div>
            <nav *ngIf="accountValue.projectCount > 0">
              <pagination-controls (pageChange)="pageChanged($event,account._id,i)" id="{{i}}"></pagination-controls>
            </nav>
          </div>
          <div class="box-body" style="display: none;">
            <div class="row" *ngIf="(accView == 1)?true:false">
              <div class="col-md-12">
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>


    <div class="backdrop" [ngStyle]="{'display':display}"></div>
    <!-- Modal -->
    <div class="modal" tabindex="-1" role="dialog" [ngStyle]="{'display':display}">
      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header pl-4 pr-4">
            <h5 class="modal-title" id="exampleModalLabel">Modal title</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="onCloseHandled()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body p-4">
            <p>Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web
              designs. The passage is attributed to an unknown typesetter in the 15th century who is thought to have
              scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book. Lorem ipsum, or
              lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. The
              passage is attributed to an unknown typesetter in the 15th century who is thought to have scrambled parts
              of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.</p>
            <p>Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web
              designs. The passage is attributed to an unknown typesetter in the 15th century who is thought to have
              scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.</p>
            <p>Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web
              designs. The passage is attributed to an unknown typesetter in the 15th century who is thought to have
              scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.</p>
            <p>Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web
              designs. The passage is attributed to an unknown typesetter in the 15th century who is thought to have
              scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.</p>
            <p>Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web
              designs. The passage is attributed to an unknown typesetter in the 15th century who is thought to have
              scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.</p>
          </div>
          <div class="modal-footer pl-4 pr-4">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary">Save changes</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
